export default function Hero() {
  return (
    <section className="relative min-h-[90vh] md:min-h-screen flex items-center overflow-hidden -mt-20">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20cleaning%20team%20in%20uniform%20working%20with%20industrial%20equipment%20in%20a%20modern%20bright%20apartment%2C%20high-end%20cleaning%20service%2C%20sparkling%20clean%20surfaces%2C%20organized%20and%20professional%20atmosphere%2C%20white%20and%20blue%20uniform%2C%20Turkish%20cleaning%20company%2C%20luxury%20residential%20cleaning&width=1920&height=1080&seq=hero-bg-1&orientation=landscape"
          alt="Profesyonel Temizlik Hizmeti"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/70 to-slate-900/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-24 md:py-32 w-full">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-sky-600/20 border border-sky-500/40 text-sky-300 text-xs md:text-sm font-semibold px-4 py-2 rounded-full mb-6 backdrop-blur-sm">
            <i className="ri-shield-check-fill" />
            18 Yıllık Profesyonel Deneyim
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-4">
            Profesyonel
            <span className="block text-sky-400">Temizlik Hizmetleri</span>
          </h1>

          {/* Sub */}
          <p className="text-xl md:text-2xl text-sky-200 font-medium mb-4">
            Ev, Araç ve Kurumsal Temizlikte Güvenilir Çözüm
          </p>

          {/* Description */}
          <p className="text-slate-300 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
            Koltuk, araç, petek temizliği ve daha fazlasında profesyonel ekip ve doğru ekipman ile hizmet veriyoruz. İstanbul Anadolu Yakası, Yalova, Karamürsel, Kocaeli ve İzmit genelinde güvenilir temizlik çözümleri.
          </p>

          {/* Phone Numbers */}
          <div className="flex flex-wrap gap-3 mb-8">
            <a
              href="tel:05055600419"
              className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white hover:bg-white/20 transition-all px-4 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap"
            >
              <i className="ri-phone-fill text-sky-400" />
              0505 560 04 19
            </a>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <a
              href="#iletisim"
              className="inline-flex items-center gap-2 bg-sky-600 hover:bg-sky-700 text-white font-bold px-7 py-4 rounded-full transition-all hover:scale-105 text-base whitespace-nowrap shadow-lg shadow-sky-900/40"
            >
              <i className="ri-calendar-check-line" />
              Hemen Randevu Al
            </a>
            <a
              href="#hizmetler"
              className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/30 text-white hover:bg-white/20 font-bold px-7 py-4 rounded-full transition-all text-base whitespace-nowrap"
            >
              Hizmetleri İncele
              <i className="ri-arrow-down-line" />
            </a>
          </div>
        </div>

        {/* Stats Floating Cards */}
        <div className="absolute bottom-8 right-4 md:right-8 hidden md:flex flex-col gap-3">
          {[
            { icon: 'ri-medal-line', value: '18+', label: 'Yıl Tecrübe' },
            { icon: 'ri-group-line', value: '5000+', label: 'Mutlu Müşteri' },
            { icon: 'ri-building-line', value: '200+', label: 'Kurumsal Müşteri' },
          ].map((stat) => (
            <div key={stat.label} className="flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-5 py-3 text-white">
              <div className="w-10 h-10 flex items-center justify-center bg-sky-600/40 rounded-xl">
                <i className={`${stat.icon} text-sky-300 text-lg`} />
              </div>
              <div>
                <div className="text-xl font-bold text-white leading-none">{stat.value}</div>
                <div className="text-xs text-slate-300 mt-0.5">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-1 text-white/50 text-xs">
        <span>Keşfet</span>
        <i className="ri-arrow-down-line animate-bounce" />
      </div>
    </section>
  );
}
